module.exports = __webpack_public_path__ + "static/img/BV.b6ed14a4.svg";